import { CheckCircle, Info, Public } from "@mui/icons-material";
import { Box, Step, StepConnector, StepLabel, Stepper, Typography, useMediaQuery } from "@mui/material";
import { colors } from "../../ui/colors";

export const WorkforceStepper = ({ activeStep, orientation = "vertical", steps: customSteps = null }) => {
  const isHorizontal = orientation === "horizontal";
  const ORANGE = colors.orange.base;
  const GRAY = colors.gray[300];

  const defaultSteps = [
    { label: "General Information", description: "Basic employee details", icon: <Info fontSize="small" /> },
    { label: "Coverage Area", description: "Define operational zones", icon: <Public fontSize="small" /> },
    { label: "Summary", description: "Review and confirm all information", icon: <CheckCircle fontSize="small" /> },
  ];

  const steps = customSteps || defaultSteps;
  const isXs = useMediaQuery("(max-width:600px)");

  const CustomStepIcon = ({ active, completed, icon }) => (
    <Box
      sx={{
        width: 28,
        height: 28,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: active || completed ? ORANGE : "#fff",
        border: `2px solid ${active || completed ? ORANGE : GRAY}`,
        color: active || completed ? "#fff" : GRAY,
        transition: "all 0.2s ease-in-out",
        zIndex: 1,
      }}
    >
      {steps[icon - 1]?.icon || icon}
    </Box>
  );

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper
        activeStep={activeStep}
        orientation={orientation}
        alternativeLabel={isHorizontal}
        connector={
          <StepConnector
            sx={{
              "&.MuiStepConnector-alternativeLabel": {
                top: 14,
                left: "calc(-50% + 10px)",
                right: "calc(50% + 10px)",
              },
              "&.MuiStepConnector-vertical": {
                ml: "14px",
                "& .MuiStepConnector-line": {
                  minHeight: 60,
                },
              },
              "& .MuiStepConnector-line": {
                borderColor: GRAY,
                borderTopWidth: isHorizontal ? 2 : 0,
                borderLeftWidth: isHorizontal ? 0 : 2,
              },
            }}
          />
        }
      >
        {steps.map((step, index) => (
          <Step key={index} sx={{ flex: 1 }}>
            <StepLabel
              StepIconComponent={CustomStepIcon}
              sx={{
                "& .MuiStepLabel-labelContainer": {
                  mt: isHorizontal ? 0.2 : 0,
                  ml: isHorizontal ? 0 : 1.5,
                  textAlign: isHorizontal ? "center" : "left",
                },
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  color: activeStep === index ? ORANGE : "#444",
                  fontSize: "0.9rem",
                  lineHeight: 1,
                }}
              >
                {step.label}
              </Typography>

              {!isHorizontal && (
                <Typography
                  variant="caption"
                  sx={{
                    color: "var(--fx-surface-texttertiary, #94A3B8)",
                    display: "block",
                    fontSize: "0.75rem",
                    mt: 0.5,
                  }}
                >
                  {step.description}
                </Typography>
              )}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
